<template>
  <editable-box :mode="mode" :includeBtns="['drag', 'delete', 'add']" @onAdd="handleAdd" @onDelete="handleDelete">
    <div class="audio-box" :class="{ 'is-edit': mode === 'edit' }">
      <div class="audio">
        <span class="icon">
          <img
            v-if="data.audio && !isPlaying"
            src="@/assets/images/audio-pause-icon.png"
            alt=""
            @click="handlePlayAudio"
          />
          <img
            v-if="data.audio && isPlaying"
            src="@/assets/images/audio-play-icon.png"
            alt=""
            @click="handlePauseAudio"
          />
          <audio v-if="data.audio" preload="none" :src="data.audio" ref="audio" @ended="handleAudioEnded"></audio>
          <upload-audio v-else-if="mode === 'edit'" @onUploaded="handleAudioUploaded"></upload-audio>
          <div class="edit-btns" v-if="data.audio && mode === 'edit'">
            <button class="btn edit-btn">
              <upload-audio type="edit" :data="data.audio" @onUploaded="handleAudioUploaded">
                <i class="wiki-icon wiki-editable-edit"></i>
              </upload-audio>
            </button>
          </div>
        </span>
        <span class="name">
          <text-box
            type="editor"
            :mode="mode"
            :image-style="{ height: '22px' }"
            :value="data.name"
            @onChange="value => handleNameChange(value)"
          >
            {{ data.name || "名称" }}
          </text-box>
        </span>
      </div>
      <div class="desc">
        <text-box
          type="editor"
          :mode="mode"
          :image-style="{ height: '22px' }"
          :value="data.desc"
          @onChange="value => handleDescChange(value)"
        >
          {{ data.desc || "描述" }}
        </text-box>
      </div>
    </div>
  </editable-box>
</template>

<script>
// components
import EditableBox from "../../../../components/EditableBox/index.jsx";
import UploadAudio from "../../../../components/UploadAudio";
import TextBox from "../../../../components/TextBox";

export default {
  name: "AudioBox",
  components: {
    EditableBox,
    UploadAudio,
    TextBox
  },
  props: {
    mode: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isPlaying: false
    };
  },
  mounted() {},

  methods: {
    handleAdd() {
      this.$emit("onAdd");
    },
    handleDelete() {
      this.$emit("onDelete");
    },
    handleNameChange(name) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.name = name;
      this.$emit("onChange", data);
    },
    handleDescChange(desc) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.desc = desc;
      this.$emit("onChange", data);
    },
    handleAudioUploaded(url) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.audio = url;
      this.$emit("onChange", data);
    },
    handlePlayAudio() {
      this.isPlaying = true;
      this.$refs.audio.play();
    },
    handlePauseAudio() {
      this.$refs.audio.pause();
      this.isPlaying = false;
    },
    handleAudioEnded() {
      this.isPlaying = false;
    }
  }
};
</script>

<style lang="less" scoped>
.audio-box {
  width: calc(100% - 27px);
  background: #f6f7f8;
  border-radius: 5px;
  margin-left: 27px;
  display: flex;
  align-items: center;
  padding: 20px;
  &.is-edit {
    .audio {
      .icon {
        &:hover {
          background-color: #c7ccd5;
          outline: #c7ccd5;
          outline-style: solid;
          outline-width: 3px;
          cursor: pointer;
          .edit-btns {
            display: inline-flex;
          }
        }
      }
    }
  }
  .audio {
    flex-shrink: 0;
    align-self: flex-start;
    display: flex;
    align-items: center;
    min-width: 98px;
    min-height: 36px;
    background: #343434;
    border-radius: 5px;
    border: 1px solid #ffffff;
    margin-right: 17px;
    margin-left: -45px;
    padding: 5px;
    gap: 5px;
    .icon {
      position: relative;
      flex-shrink: 0;
      border-radius: 100%;
      display: inline-block;
      width: 24px;
      height: 24px;
      background: #ffffff;
      border: 1px solid #ffffff;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .edit-btns {
        display: none;
        position: absolute;
        height: 20px;
        right: 0px;
        top: -20px;
        .btn {
          width: 20px;
          height: 20px;
          color: #ffffff;
          border-radius: 4px;
          margin-left: 3px;
          border: none;
          vertical-align: middle;
          line-height: 20px;
          text-align: center;
          overflow: hidden;
          &:hover {
            opacity: 0.9;
          }
          .wiki-icon {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .name {
      display: inline-block;
      vertical-align: middle;
      width: 100%;
      font-size: 14px;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
    }
  }

  .desc {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #373737;
    line-height: 22px;
  }
}
</style>
